import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { PostListFilterByEnum, PostListFilterByOperator, PostListOrderByEnum, } from '@tribeplatform/gql-client/types';
import { useAuthMember, useFeed } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { useQuery } from '../common';
import { GenericPostList } from '../PostList/GenericPostList';
import { PostListFilter } from '../PostList/PostListFilter';
import { getUserSettings, setUserSetting } from '../utils/userSettings';
import { EmptyState } from './EmptyState';
export const Feed = ({ view = 'card', orderBy: defaultOrderBy = PostListOrderByEnum.publishedAt, }) => {
    var _a, _b;
    const { isGuest } = useAuthMember();
    const userSettingOrderBy = (_b = (_a = getUserSettings()) === null || _a === void 0 ? void 0 : _a.postListOrderBy) === null || _b === void 0 ? void 0 : _b.Feed;
    const [orderBy, setOrderBy] = useState(userSettingOrderBy || defaultOrderBy);
    const { tag_id: tagId } = useQuery();
    const filterBy = [];
    if (tagId) {
        filterBy.push({
            key: PostListFilterByEnum.publishedAt,
            keyString: 'tagIds',
            operator: PostListFilterByOperator.contains,
            value: JSON.stringify(tagId),
        });
    }
    useEffect(() => {
        setUserSetting('postListOrderBy', {
            Feed: orderBy,
        });
    }, [orderBy]);
    const { data, fetchNextPage = false, hasNextPage, isLoading, isFetched, isFetchingNextPage, } = useFeed({
        fields: {
            tags: 'basic',
            owner: {
                member: { profilePicture: 'basic', badges: 'all' },
            },
            embeds: 'basic',
            mentions: 'basic',
            space: 'basic',
            attachments: 'basic',
            authMemberProps: 'all',
            reactions: { fields: 'all', variables: { limit: 10 } },
            replies: {
                fields: {
                    authMemberProps: 'all',
                    embeds: 'basic',
                    mentions: 'basic',
                    attachments: 'basic',
                    owner: {
                        member: { profilePicture: 'basic', badges: 'all' },
                    },
                    reactions: { fields: 'all', variables: { limit: 10 } },
                },
                variables: {
                    limit: 2,
                    reverse: true,
                },
            },
        },
        variables: {
            limit: view === 'card' ? 5 : 10,
            onlyMemberSpaces: !isGuest,
            orderBy,
            filterBy,
        },
        useInfiniteQueryOptions: {
            refetchOnMount: 'always',
        },
    });
    const { nodes: posts } = simplifyPaginatedResult(data);
    return (_jsxs("div", { children: [_jsx(PostListFilter, { orderBy: orderBy, setOrderBy: setOrderBy }, void 0), _jsx(GenericPostList, { hasNextPage: hasNextPage, isLoading: isLoading, isFetchingNextPage: isFetchingNextPage, fetchNextPage: fetchNextPage, posts: posts, isFetched: isFetched, view: view, emptyState: _jsx(EmptyState, {}, void 0), context: "network" }, void 0)] }, void 0));
};
//# sourceMappingURL=Feed.js.map